import React, { useContext, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getDataStructure, getDataStructureDO, getProfiles, getSchoolYears } from '../../../actions/disciplineStructure'
import styles from '../styles.module.scss'
import { DisciplineStructureContext } from '../../../utils/context'
import { COURSE_TYPE_CONFIG } from '../config'
import CustomSelect from '../../../components/CustomSelect'
import { getCurrentYearUtils } from '../../../utils/classBook'
import moment from 'moment'

const EDU_TYPES = [
  { name: 'Основное', value: 0, path: '/discipline_structure_ba' },
  { name: 'Дополнительное', value: 1, path: '/discipline_structure_do' },
  { name: 'Внеурочная деятельность', value: 2, path: '/discipline_structure_vd' }
]
const years = [
  {
    "xp_key": 6,
    "name": "2026-2027"
  },
  {
    "xp_key": 3,
    "name": "2025-2026"
  },
  {
    "xp_key": 2,
    "name": "2024-2025"
  },
  {
    "xp_key": 1,
    "name": "2023-2024"
  }
]

export default function Form() {
  const navigate = useNavigate()
  const { form, initialValues } = useContext(DisciplineStructureContext)

  const { values, setFieldValue, setValues } = form
  const dispatch = useDispatch()
  const { schoolYears, peoples, courses, profiles, list_mid, list_cid, list_trp } = useSelector(state => state.discipline_structure.filters)
  const { data } = useSelector(state => state.discipline_structure || [])
  const isYearSetRef = useRef(false)
  const prevMidRef = useRef(undefined)
  const prevCidRef = useRef(undefined)

  useEffect(() => {
    dispatch(getSchoolYears())
    dispatch(getProfiles())
  }, [])

  useEffect(() => {
    if (schoolYears?.length && !isYearSetRef.current && (values?.xp_key === 0 || !values?.xp_key)) {
      const currentYear = getCurrentYearUtils(schoolYears, moment().format('YYYY-MM-DD'))

      if (currentYear) {
        setFieldValue('xp_key', currentYear)
        isYearSetRef.current = true
      } else {
        // Если текущий год не найден, устанавливаем первый год из списка
        if (schoolYears[0]?.xp_key) {
          setFieldValue('xp_key', schoolYears[0].xp_key)
          isYearSetRef.current = true
        }
      }
    }
  }, [schoolYears])

  useEffect(() => {
    if (values?.course_type === undefined || values?.course_type === null) return;
    if (!values?.xp_key || values?.xp_key === 0) return;

    const { course_type, xp_key } = values || {}

    // Сбрасываем фильтры только при изменении года или типа образования
    setFieldValue('trp_id', null)
    setFieldValue('mid', null)
    setFieldValue('cid', null)

    const params = {
      course_type,
      xp_key,
    };

    // Загружаем списки фильтров (преподавателей, предметов)
    if (course_type === 1) {
      dispatch(getDataStructureDO(params))
    } else {
      dispatch(getDataStructure(params))
    }
  }, [values?.course_type, values?.xp_key])

  useEffect(() => {
    if (prevMidRef.current === undefined) { prevMidRef.current = values?.mid; return; }
    if (prevMidRef.current === values?.mid) return;
    prevMidRef.current = values?.mid
    setFieldValue('cid', null)
    setFieldValue('trp_id', null)
    dispatch({ type: 'SET_DISCIPLINE_STRUCTURE_FILTER_TRP', payload: [] })
  }, [values?.mid])

  useEffect(() => {
    if (prevCidRef.current === undefined) { prevCidRef.current = values?.cid; return; }
    if (prevCidRef.current === values?.cid) return;
    prevCidRef.current = values?.cid
    setFieldValue('trp_id', null)
    dispatch({ type: 'SET_DISCIPLINE_STRUCTURE_FILTER_TRP', payload: [] })
  }, [values?.cid])

  useEffect(() => {
    if (values?.course_type === undefined || values?.course_type === null) return;
    if (!values?.xp_key || values?.xp_key === 0) return;

    const { course_type, xp_key, trp_id, mid, cid } = values || {}

    const params = {
      course_type,
      xp_key,
      ...(trp_id !== undefined && trp_id !== null && { trp_id }),
      ...(mid !== undefined && mid !== null && mid !== 0 && { mid }),
      ...(cid !== undefined && cid !== null && cid !== 0 && { cid }),
    };

    if (course_type === 1) {
      dispatch(getDataStructureDO(params))
    } else {
      dispatch(getDataStructure(params))
    }
  }, [values?.trp_id, values?.mid, values?.cid])



  useEffect(() => {
    const params = { course_type: values?.educationType }
    // dispatch(getCourses(values?.year, values?.teacher, params))
    // dispatch(getDataStructure(params))
  }, [values?.educationType, values?.year])

  const convertToSelectOptions = (items) => {
    if (!items || !Array.isArray(items)) return []
    return items.map(item => {
      const { xp_key, trp_id, name, cid, mid, fio, title, teacher_mid, teacher, predmet, iod } = item
      const optionName = name || title || fio || teacher || predmet
      const optionValue = xp_key || iod || trp_id || cid || mid || teacher_mid
      return { name: optionName, value: optionValue }
    })
  }

  const convertProfilesToOptions = (items) => {
    if (!items || !Array.isArray(items)) return []
    return items
      .filter(item => item.level === 0)
      .map(item => ({ name: item.title, value: item.oid }))
  }

  const handleEduTypeChange = (fieldName, value) => {
    const eduType = EDU_TYPES.find(type => type.value === value)
    if (eduType) {
      setValues({ ...initialValues, course_type: value })
      navigate(eduType.path)
    }
  }


  return (
    <form className={styles.form}>
      <div className={styles.filtersBlock}>
        <CustomSelect
          title='Образование'
          options={EDU_TYPES}
          value={values?.course_type}
          setFieldValue={handleEduTypeChange}
          valuesName='course_type'
          width={220}
          withoutAll
        />

        <CustomSelect
          title='Учебный год'
          options={convertToSelectOptions(schoolYears?.length ? schoolYears : years)}
          value={values?.xp_key}
          setFieldValue={setFieldValue}
          valuesName='xp_key'
          width={220}
        />

        <CustomSelect
          title='Преподаватель'
          options={convertToSelectOptions(list_mid)}
          value={values?.mid}
          setFieldValue={setFieldValue}
          valuesName='mid'
          width={320}
        />
        <CustomSelect
          title='Предмет'
          options={convertToSelectOptions(list_cid)}
          value={values?.cid}
          setFieldValue={setFieldValue}
          valuesName='cid'
          width={280}
        />

        <CustomSelect
          title='Профиль'
          options={convertProfilesToOptions(list_trp)}
          value={values?.trp_id}
          setFieldValue={setFieldValue}
          valuesName='trp_id'
          width={220}
        />
      </div>
    </form>
  )
}
